import React from 'react';
import { Route, Switch } from 'react-router-dom';
// components
import PageLayout from './components/ui/page/pageLayout';
// pages
import TicketsListPage from './pages/ticketsListPage';
import NewTicketPage from './pages/newTicketPage';
import TicketDetailPage from './pages/ticketDetailPage';
import TicketRepeatPage from './pages/ticketRepeatPage';
import NewQuotePage from './pages/newQuotePage';
import QuoteDetailPage from './pages/quoteDetailPage';
//styles
import 'modules/emergencies/components/ui/emergencyPopup.css';
import FilterViewsListPage from './pages/filterViewsListPage';
import NewFilterViewPage from './pages/newFilterViewPage';
import usePriceNegotiationPermissions from './permissions/usePriceNegotiationPermissions';
import PRICE_NEGOTIATION_PERMISSIONS_NAMES from './permissions/priceNegotiationPermissionsNames';

const EmergenciesModule = ({ match }) => {
  const canCreateQuote = usePriceNegotiationPermissions(
    PRICE_NEGOTIATION_PERMISSIONS_NAMES.QUOTE_CREATION
  );
  return (
    <PageLayout>
      <Switch>
        <Route path={`${match?.url}`} exact component={TicketsListPage} />
        <Route path={`${match?.url}/new`} component={NewTicketPage} />
        <Route path={`${match?.url}/repeat/:id`} component={TicketRepeatPage} />
        <Route path={`${match?.url}/filter-views/new`} component={NewFilterViewPage} />
        <Route path={`${match?.url}/filter-views`} component={FilterViewsListPage} />
        {canCreateQuote && <Route path={`${match?.url}/:id/quote/new`} component={NewQuotePage} />}
        <Route path={`${match?.url}/:id/quote/:quoteId`} component={QuoteDetailPage} />
        <Route path={`${match?.url}/:id`} component={TicketDetailPage} />
      </Switch>
    </PageLayout>
  );
};

export default EmergenciesModule;
